const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

const Select = require('react-select');
const { Errors } = require('react-redux-form');
import { formatText } from 'core/i18n';

class GeoSelect extends React.Component {
    constructor(props) {
        super(props);

        this.handleOnChange = this.handleOnChange.bind(this);
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.props.value !== newProps.value) {
            this.props.onUpdate && this.props.onUpdate(newProps.baseModelProperty, newProps.value);

            if (this.props.validators) {
                this.props.formActions.validate(
                    `${this.props.baseModelDescriptor}.${this.props.baseModelProperty}`,
                    this.props.validators
                );
            }
        }
    }

    handleOnChange(selection) {
        if (selection) {
            this.props.formActions.change(
                `${this.props.baseModelDescriptor}.${this.props.baseModelProperty}`,
                selection.value
            );
        } else {
            this.props.formActions.change(`${this.props.baseModelDescriptor}.${this.props.baseModelProperty}`, '');
        }
    }

    renderErrors(props) {
        return <div className="form__field_error">{props.children}</div>;
    }

    renderLabel() {
        return this.props.label ? <label htmlFor={this.props.id}>{this.props.label}</label> : null;
    }

    render() {
        const { className, size } = this.props;
        const hasError = !(this.props.baseModelForm?.[this.props.baseModelProperty]?.valid ?? true);
        const mainClassNames = classNames('form__select', 'prospects-geo-select', className, {
            'form__select--error': hasError,
        });

        const inputClassNames = classNames({
            'valid-error': hasError,
        });

        return (
            <div className={`${mainClassNames} col-sm-${size}`}>
                {this.renderLabel()}
                {this.props.tooltip}
                <Select.Creatable
                    inputProps={{ autoComplete: this.props.autoCompleteFieldCustom ? 'on' : 'new-text' }}
                    className={inputClassNames}
                    id={this.props.id}
                    value={this.props.value}
                    options={this.props.options}
                    autoBlur={this.props.autoBlur}
                    onChange={this.handleOnChange}
                    clearable={this.props.clearable}
                    placeholder={this.props.placeholder}
                    closeTimeOutMS={150}
                    searchable={this.props.searchable}
                    disabled={this.props.disabled}
                    noResultsText={this.props.noResultsText}
                    isValidNewOption={() => false}
                />
                <Errors
                    model={`${this.props.baseModelDescriptor}.${this.props.baseModelProperty}`}
                    messages={this.props.errorMessages}
                    component={this.renderErrors}
                />
            </div>
        );
    }
}

GeoSelect.propTypes = {
    id: PropTypes.string.isRequired,
    baseModelDescriptor: PropTypes.string,
    baseModelProperty: PropTypes.string.isRequired,
    baseModelForm: PropTypes.object,
    formActions: PropTypes.object,
    value: PropTypes.string.isRequired,
    gmapsType: PropTypes.oneOf(['type_of_road', 'administrative_area_level_2', 'other']).isRequired,
    label: PropTypes.string,
    tooltip: PropTypes.node,
    options: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })),
    autoBlur: PropTypes.bool,
    autoCompleteFieldCustom: PropTypes.bool,
    clearable: PropTypes.bool,
    placeholder: PropTypes.string,
    searchable: PropTypes.bool,
    disabled: PropTypes.bool,
    noResultsText: PropTypes.string,
    errorMessages: PropTypes.object,
    size: PropTypes.number,
    onUpdate: PropTypes.func,
};

GeoSelect.defaultProps = {
    clearable: true,
    autoCompleteFieldCustom: false,
    searchable: true,
    disabled: false,
    autoBlur: true,
    placeholder: formatText('field-selectAnOption'),
    tooltip: null,
    label: 'Label',
    noResultsText: formatText('validation-noResultsFound'),
    value: '',
    size: 12,
};

module.exports = GeoSelect;
